import { useEffect, useState } from 'react';
import { database } from '../config/firebase';
import { ref, onValue, set, onDisconnect, serverTimestamp } from 'firebase/database';

export const useOnlinePresence = (userId: string | undefined, userName: string | undefined) => {
    const [onlineCount, setOnlineCount] = useState(0);
    const [onlineUsers, setOnlineUsers] = useState<Record<string, any>>({});

    useEffect(() => {
        if (!userId || !userName) return;

        // References
        const connectedRef = ref(database, '.info/connected');
        const userStatusRef = ref(database, `chat/presence/${userId}`);
        const presenceRef = ref(database, 'chat/presence');

        // Monitor connection state
        const unsubscribeConnected = onValue(connectedRef, (snap) => {
            if (snap.val() === true) {
                // We're connected (or reconnected)!

                // 1. Set disconnect handler first
                onDisconnect(userStatusRef).remove();

                // 2. Set user as online
                set(userStatusRef, {
                    online: true,
                    userName: userName,
                    lastSeen: serverTimestamp()
                });
            }
        });

        // Sub to online count and list
        const unsubscribePresence = onValue(presenceRef, (snap) => {
            const data = snap.val();
            if (data) {
                setOnlineCount(Object.keys(data).length);
                setOnlineUsers(data);
            } else {
                setOnlineCount(0);
                setOnlineUsers({});
            }
        });

        return () => {
            unsubscribeConnected();
            unsubscribePresence();
        };
    }, [userId, userName]);

    return { onlineCount, onlineUsers };
};
